module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"to":"To","cc":"CC","bcc":"BCC","from":"From","subject":"Subject","fieldIsEmpty":"Field is empty","invalidEmail":"Email is invalid"},"es":{"to":"Para","cc":"CC","bcc":"BCC","from":"De","subject":"Motivo","fieldIsEmpty":"El campo esta vació","invalidEmail":"Correo inválido"}}')
  delete Component.options._Ctor
}
